import { createGlobalStyle } from 'styled-components';
import { FONT_FAMILY_STACK } from 'themes/createTypography';
import { interFontStyle } from 'themes/interFont';
/* note, the _:-ms-lang.. blah blah is a way to identify a microsoft browser (bleccch) */
// https://stackoverflow.com/questions/32201586/how-to-identify-microsoft-edge-browser-via-css

// On body rather than on each typography variant, so text outside a variant (plain elements,
// styled-components, chart tooltip HTML) inherits the same Inter glyphs.
const inter = interFontStyle();

const GlobalStyles = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body iframe {
    opacity: ${process.env.PROJECT === 'acme' ? '1' : '0.5'};
  }
  body iframe:hover {
    opacity: 1;
  }
  _:-ms-lang(x), _:-webkit-full-screen, body iframe
  {
      opacity: 1;
  }

  body {
    font-family: ${({ theme }) => theme?.typography?.fontFamily || FONT_FAMILY_STACK};
    font-optical-sizing: ${inter.fontOpticalSizing};
    ${inter.fontVariationSettings ? `font-variation-settings: ${inter.fontVariationSettings};` : ''}
    ${inter.fontFeatureSettings ? `font-feature-settings: ${inter.fontFeatureSettings};` : ''}
  }

  /* The browser's form-control font shorthand resets these to their initial values, so controls
     would otherwise drop the Inter features set on body. */
  button,
  input,
  select,
  textarea {
    font-optical-sizing: inherit;
    font-variation-settings: inherit;
    font-feature-settings: inherit;
  }

  #app {
    min-height: 100%;
    min-width: 100%;
  }

  input::-ms-clear {
    display: none;
  }

  #main {
    margin: 0 auto;
    min-height: 100%;
    max-width: 100%;
  }

  input:-webkit-autofill{
    border-radius: inherit !important;
 }
`;

export default GlobalStyles;
